/**
 * Application Configuration Constants
 */

// Language configuration
export const LANGUAGES = {
  ENGLISH: 'en',
  HINDI: 'hi',
  GUJARATI: 'gu',
};

export const LANGUAGE_LABELS = {
  en: 'English',
  hi: 'हिन्दी',
  gu: 'ગુજરાતી',
};

// Default page states
export const PAGE_STATES = {
  HOME: 'home',
  PRESET: 'services',
};
